module.exports = __webpack_public_path__ + "static/media/stars.75f8e1bd.svg";